<template>
  <div class="wrap talk re-style">
    <header>
      <h1><a href="#" class="logo"></a></h1>
    </header>
    <div v-if="delYet" class="container">
      <main class="content">
        <template v-if="!isHomeYn">
          <article class="certification">
            <section class="txt agree-bg"></section>
            <section v-if="!isHomeYn">
              <div class="chbox row row_c row_jsc">
                <h2 style="font-size: 18px; font-weight: 800">
                  발행 대기 중입니다
                </h2>
                <br />
                <p>데이터삭제 인증서는</p>
                <p>검수센터 입고 후 확인할 수 있어요</p>
                <br />
                <p>영업일 기준 약 7일 정도 소요되며,</p>
                <p>입고 상황에 따라 달라질 수 있어요</p>
              </div>
            </section>
            <div class="btn-wrap">
              <a
                href="javascript:void(0);"
                class="talk-btn btn-black"
                @click.stop.prevent="complete()"
                >확인</a
              >
            </div>
            <section>
              <div
                class="row row_c row_jsc"
                style="
                  position: relative;
                  text-align: center;
                  margin-top: 60px;
                  line-height: 18px;
                  color: #8b8b8b;
                "
              >
                <h1 style="margin-bottom: 10px">고객센터 문의</h1>
                <p style="font-size: 12px">일반 민팃 : <span>1877-5446</span></p>
              </div>
            </section>
          </article>
        </template>
        <template v-else>
          <article  class="certification">
            <section class="txt return">
              <p class="return-txt pad_b20" style="line-height: 20px;">
                <span class="return-txt-span">발급 대기중이에요</span>
                <br />
                데이터삭제 인증서 발급까지는
                <br />
                판매여부 결정 후 2일 정도 소요돼요
                <br />
                <br />
                발급된 인증서는 진단 결과 알림톡에서
                <br />
                확인하실 수 있어요
              </p>
            </section>
          </article>
          <div id="regBtnDiv" class="ui-buttons">
            <ul class="ui-buttons__list">
              <li class="ui-buttons__item">
                <button
                  type="button"
                  class="ui-button ui-basic-button"
                  @click="complete()"
                >
                  확인
                </button>
              </li>
            </ul>
          </div>
          <div class="cs-center row row_ac row_jsc">
            <span class="qa">고객센터 문의 </span>
            <span><a href="tel:1877-5446" class="en phone">1877-5446</a></span>
          </div>
        </template>

      </main>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import isEmpty from 'lodash/isEmpty'

export default {
  name: 'delCert',
  data () {
    return {
      ordNum: '',
      delYet: false,
      isHomeYn: false
    }
  },
  async mounted () {
    this.ordNum = decodeURIComponent(this.$route.query.ordNum).trim()
    if (!this.ordNum) {
      this.$Alert.alert('잘못된 접수번호 입니다.')
      return
    }
    try {
      const resData = await this.$http.get(
        '/api/purchase/logitics/public/delCert',
        {
          params: { ordNum: this.ordNum }
        }
      )

      // 민팃Home일경우 텍스트 노출 분기.
      const res = resData.data.result
      if (!isEmpty(res)) {
        if (!isEmpty(res.exists)) {
          window.location.href = res.exists
        } else {
          this.delYet = true
          if (res.homeYn === 'Y') {
            this.isHomeYn = true
          }
        }
      } else {
        this.delYet = true
      }
    } catch (e) {
      this.$Alert.alert('서버 요청 중 오류가 발생했습니다.')
    }
  },
  methods: {
    async complete () {
      const ua = navigator.userAgent.toLowerCase()
      if (ua.indexOf('kakaotalk') > -1) {
        if (
          ua.indexOf('iphone') > -1 ||
          ua.indexOf('ipad') > -1 ||
          ua.indexOf('ipod') > -1
        ) {
          window.location.href = 'kakaoweb://closeBrowser'
        } else {
          window.location.href = 'kakaotalk://inappbrowser/close'
        }
      } else if (window) {
        if (window.opener) {
          window.opener.close()
        }
        window.close()
      }
    }
  }
}
</script>
<style>
.return-txt-span{
  font-weight: bold;
  font-size:18px;
  margin-bottom: 20px;
}
p {
  font-size: 14px;
  font-weight: 400;
}
span {
  font-weight: 800;
}
</style>



// WEBPACK FOOTER //
// src/views/purchase/delCert.vue